import { Bewerber } from '../../../types/bewerber';
import { ZurKlaerungModal } from '../ZurKlaerungModal';
import { EinladenModal } from '../EinladenModal';
import { SelectBedarfKennenlernenModal } from '../SelectBedarfKennenlernenModal';
import { ArbeitsvertragModal } from '../ArbeitsvertragModal';
import { AbsageModal } from '../AbsageModal';
import { ReactivateModal } from '../ReactivateModal';
import { NichtGeeignetModal } from '../NichtGeeignetModal';
import { HardDeleteModal } from '../HardDeleteModal';
import { AnfordernModal } from '../AnfordernModal';
import { ModalState } from './useBewerberActions';
import { EinladenModalProps } from './useEinladenBewerber';

interface BewerberActionModalsProps {
  bewerber: Bewerber;
  modals: {
    zurKlaerung: ModalState;
    kennenlernen: ModalState;
    arbeitsvertrag: ModalState;
    absage: ModalState;
    reactivate: ModalState;
    nichtGeeignet: ModalState;
    hardDelete: ModalState;
    anfordern: ModalState;
  };
  einladenModalProps: EinladenModalProps;
  onModalComplete?: () => void;
}

export function BewerberActionModals({
  bewerber,
  modals,
  einladenModalProps,
  onModalComplete,
}: BewerberActionModalsProps) {
  const bewerberName = `${bewerber.firstName} ${bewerber.lastName}`;

  const handleZurKlaerungClose = () => {
    modals.zurKlaerung.close();
    onModalComplete?.();
  };

  const handleKennenlernenClose = () => {
    modals.kennenlernen.close();
    onModalComplete?.();
  };

  const handleArbeitsvertragClose = () => {
    modals.arbeitsvertrag.close();
    onModalComplete?.();
  };

  const handleAbsageClose = () => {
    modals.absage.close();
    onModalComplete?.();
  };

  const handleReactivateClose = () => {
    modals.reactivate.close();
    onModalComplete?.();
  };

  const handleNichtGeeignetClose = () => {
    modals.nichtGeeignet.close();
    onModalComplete?.();
  };

  const handleHardDeleteClose = () => {
    modals.hardDelete.close();
    onModalComplete?.();
  };

  const handleAnfordernClose = () => {
    modals.anfordern.close();
    onModalComplete?.();
  };

  return (
    <>
      <ZurKlaerungModal
        isOpen={modals.zurKlaerung.isOpen}
        onClose={handleZurKlaerungClose}
        bewerberId={bewerber.id}
        bewerberName={bewerberName}
      />

      <EinladenModal {...einladenModalProps} />

      <SelectBedarfKennenlernenModal
        isOpen={modals.kennenlernen.isOpen}
        onClose={handleKennenlernenClose}
        bewerberId={bewerber.id}
        bewerberName={bewerberName}
        onSuccess={handleKennenlernenClose}
      />

      <ArbeitsvertragModal
        isOpen={modals.arbeitsvertrag.isOpen}
        onClose={() => modals.arbeitsvertrag.close()}
        bewerber={bewerber}
        onSuccess={handleArbeitsvertragClose}
      />

      <AbsageModal
        isOpen={modals.absage.isOpen}
        onClose={() => modals.absage.close()}
        bewerber={bewerber}
        onSuccess={handleAbsageClose}
      />

      <ReactivateModal
        isOpen={modals.reactivate.isOpen}
        onClose={() => modals.reactivate.close()}
        bewerber={bewerber}
        onSuccess={handleReactivateClose}
      />

      <NichtGeeignetModal
        isOpen={modals.nichtGeeignet.isOpen}
        onClose={() => modals.nichtGeeignet.close()}
        bewerber={bewerber}
        onSuccess={handleNichtGeeignetClose}
      />

      <HardDeleteModal
        isOpen={modals.hardDelete.isOpen}
        onClose={() => modals.hardDelete.close()}
        bewerber={bewerber}
        onSuccess={handleHardDeleteClose}
      />

      <AnfordernModal
        isOpen={modals.anfordern.isOpen}
        onClose={() => modals.anfordern.close()}
        bewerber={bewerber}
        onSuccess={handleAnfordernClose}
      />
    </>
  );
}
